/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './getRelationships.defs.js'
export * as $defs from './getRelationships.defs.js'
